<template>
  <div class="home-page">
    <!-- 顶部导航 -->
    <header class="top-header">
      <div class="header-inner">
        <div class="logo">
          <div class="logo-icon">
            <img src="@/assets/icon/banner.png" alt="logo" />
          </div>
          <span class="logo-text">杭州梵艺科技有限公司</span>
        </div>
      </div>
    </header>

    <!-- 主体容器 -->
    <main class="main-container">
      <!-- 首屏 Banner 区 -->
      <section class="banner-section">
        <!-- 左侧排行榜 -->
        <div class="rank-card">
          <div class="rank-title">
            <span class="rank-icon">🏆</span>
            <span>热门排行</span>
          </div>
          <ul class="rank-list">
            <li v-for="(item, index) in rankList" :key="index" class="rank-item" @click="goToGame(item)">
              <div class="rank-num" :class="'rank-num-' + (index + 1)">{{ index + 1 }}</div>
              <div class="rank-avatar">
                <img :src="item.iconUrl" :alt="item.name" />
              </div>
              <div class="rank-name">{{ item.name }}</div>
            </li>
          </ul>
        </div>

        <!-- 右侧轮播 Banner -->
        <div class="banner-carousel" @mouseenter="pauseBanner" @mouseleave="resumeBanner">
          <div class="banner-track">
            <img
              v-for="(src, i) in bannerImages"
              :key="i"
              :src="src"
              class="banner-slide"
              :class="{ active: i === currentBanner }"
              alt="banner"
            />
          </div>
          <div class="carousel-dots">
            <span
              v-for="(src, i) in bannerImages"
              :key="i"
              class="dot"
              :class="{ active: i === currentBanner }"
              @click="goToBanner(i)"
            ></span>
          </div>
        </div>
      </section>

      <!-- 游戏推荐区 -->
      <section class="block-section">
        <div class="section-header">
          <div class="section-title">
            <span class="title-bar"></span>
            <span>游戏推荐</span>
          </div>
<!--          <a class="more-link">更多游戏 &gt;</a>-->
        </div>

        <div class="recommend-icons">
          <div v-for="(g, i) in recommendGames" :key="i" class="game-icon-item" @click="goToGame(g)">
            <div class="game-icon">
              <img :src="g.iconUrl" :alt="g.name" />
            </div>
            <div class="game-name">{{ g.name }}</div>
          </div>
        </div>

        <div class="big-cards">
          <div
            v-for="(g, i) in bigCards"
            :key="i"
            class="big-card"
            :class="g.variant === 'cool' ? 'big-card-2' : 'big-card-1'"
            :style="bigCardStyle(g)"
            @click="goToGame(g)"
          >
            <div class="big-card-overlay"></div>
            <div class="big-card-info">
              <div class="big-card-icon">
                <img :src="g.iconUrl" :alt="g.name" />
              </div>
              <div class="big-card-title">{{ g.name }}</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 棋牌专区 -->
      <section class="block-section">
        <div class="section-header">
          <div class="section-title">
            <span class="title-bar"></span>
            <span>棋牌专区</span>
          </div>
<!--          <a class="more-link">更多 &gt;</a>-->
        </div>
        <div class="card-row">
          <div v-for="(g, i) in chessGames" :key="i" class="game-card" :style="{ background: g.bg }" @click="goToGame(g)">
            <div class="game-card-img">
              <img class="game-card-icon" :src="g.iconUrl" :alt="g.name" />
            </div>
            <div class="game-card-name">{{ g.name }}</div>
          </div>
        </div>
      </section>

      <!-- 休闲专区 -->
      <section class="block-section">
        <div class="section-header">
          <div class="section-title">
            <span class="title-bar"></span>
            <span>休闲专区</span>
          </div>
<!--          <a class="more-link">更多 &gt;</a>-->
        </div>
        <div class="card-row">
          <div v-for="(g, i) in casualGames" :key="i" class="game-card" :style="{ background: g.bg }" @click="goToGame(g)">
            <div class="game-card-img">
              <img class="game-card-icon" :src="g.iconUrl" :alt="g.name" />
            </div>
            <div class="game-card-name">{{ g.name }}</div>
          </div>
        </div>
      </section>

      <!-- 微信游戏区 -->
      <section class="block-section">
        <div class="section-header">
          <div class="section-title">
            <span class="title-bar"></span>
            <span>微信游戏</span>
          </div>
<!--          <a class="more-link">更多 &gt;</a>-->
        </div>
        <div class="wechat-grid">
          <div v-for="(g, i) in wechatGames" :key="i" class="wechat-item" @click="goToGame(g)">
            <div class="wechat-icon">
              <img :src="g.iconUrl" :alt="g.name" />
            </div>
            <div class="wechat-name">{{ g.name }}</div>
            <div class="wechat-tag">{{ g.tag }}</div>
          </div>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-inner">
        <div class="footer-logo">
          <img src="@/assets/icon/banner.png" alt="logo" />
        </div>
        <div class="footer-links">
<!--          <a>关于社区</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>联系我们</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>商务合作</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>普通开放平台</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>家长监护</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>广告合作</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>账号交易平台</a>-->
        </div>
        <div class="footer-copyright">
          © 2024-2026 杭州梵艺科技有限公司 版权所有 &nbsp; 浙ICP备B2-20100031-1 &nbsp;
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import product from "@/mock/product.json";

const mergeList = (list, games, extra = {}) =>
  list
    .map(item => {
      const g = games[item.id];
      if (!g) return null;
      return { ...g, ...item, ...extra };
    })
    .filter(Boolean);

const BANNER_INTERVAL = 6000;

const bigCardBgContext = require.context("@/assets/png", false, /\.(png|jpe?g)$/);
const bigCardBgByName = name => {
  try { return bigCardBgContext("./" + name); } catch (e) { return null; }
};
const BIG_CARD_BG = {
  "hanfeng-three-kingdoms": bigCardBgByName("h3_banner.png"),
  "journey-to-west-ol": bigCardBgByName("xi_banner.png")
};

export default {
  name: "HomePage",
  data() {
    const { games, home } = product;
    return {
      bannerImages: [
        require("@/assets/slider_banner/banner3.png"),
        require("@/assets/slider_banner/banner4.png"),
        require("@/assets/slider_banner/banner5.png")
      ],
      currentBanner: 0,
      bannerTimer: null,
      rankList: mergeList(home.rankList, games),
      recommendGames: mergeList(home.recommendGames, games).map(g => ({
        ...g,
        short: g.short || g.shortName,
        color: g.color || g.iconColor
      })),
      bigCards: mergeList(home.bigCards, games),
      chessGames: mergeList(home.chessGames, games).map(g => ({
        ...g,
        emoji: g.emoji || g.icon
      })),
      casualGames: mergeList(home.casualGames, games).map(g => ({
        ...g,
        emoji: g.emoji || g.icon
      })),
      wechatGames: mergeList(home.wechatGames, games).map(g => ({
        ...g,
        short: g.short || g.shortName,
        color: g.color || g.iconColor
      }))
    };
  },
  mounted() {
    this.startBanner();
  },
  beforeDestroy() {
    this.stopBanner();
  },
  methods: {
    goToGame(g) {
      if (!g) return;
      if (g.hasDetail) {
        this.$router.push({ path: "/game-detail", query: { id: g.id } });
      } else if (g.link) {
        window.open(g.link, "_blank");
      }
    },
    bigCardStyle(g) {
      const bg = BIG_CARD_BG[g && g.id];
      return bg
        ? { backgroundImage: `url(${bg})`, backgroundSize: "cover", backgroundPosition: "center" }
        : null;
    },
    startBanner() {
      this.stopBanner();
      this.bannerTimer = setInterval(() => {
        this.currentBanner = (this.currentBanner + 1) % this.bannerImages.length;
      }, BANNER_INTERVAL);
    },
    stopBanner() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer);
        this.bannerTimer = null;
      }
    },
    pauseBanner() {
      this.stopBanner();
    },
    resumeBanner() {
      this.startBanner();
    },
    goToBanner(i) {
      this.currentBanner = i;
      this.startBanner();
    }
  }
};
</script>

<style lang="less" scoped>
.home-page {
  width: 100%;
  background: #F5F5F5;
  min-width: 1366px;
  font-family: PingFangSC-Regular, "Microsoft YaHei", sans-serif;
  color: #333;
}

/* 顶部导航 */
.top-header {
  width: 100%;
  height: 56px;
  background: linear-gradient(90deg, #4A90E2 0%, #6AB0F2 100%);
  box-shadow: 0 2px 8px rgba(74,144,226,0.15);
  .header-inner {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    display: flex;
    align-items: center;
    .logo-icon {
      width: 32px;
      height: 32px;
      background: #fff;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    .logo-text {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }
  .top-nav {
    display: flex;
    .nav-item {
      color: #fff;
      font-size: 15px;
      margin-left: 32px;
      cursor: pointer;
      padding: 4px 0;
      border-bottom: 2px solid transparent;
      transition: all 0.2s;
      &:hover { opacity: 0.85; }
      &.active { border-bottom: 2px solid #fff; font-weight: bold; }
    }
  }
}

/* 主容器 */
.main-container {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0 40px;
}

/* Banner 区 */
.banner-section {
  display: flex;
  gap: 16px;
  height: 280px;
  margin-bottom: 24px;
}

.rank-card {
  width: 240px;
  background: #fff;
  border-radius: 10px;
  padding: 14px 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  .rank-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    color: #4A90E2;
    margin-bottom: 10px;
    .rank-icon { margin-right: 6px; }
  }
  .rank-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .rank-item {
    display: flex;
    align-items: center;
    padding: 10px 4px;
    border-bottom: 1px dashed #eee;
    transition: background 0.2s;
    &:last-child { border-bottom: none; }
    &:hover { background: #f5f9ff; }
    .rank-num {
      width: 22px;
      height: 22px;
      background: #ccc;
      color: #fff;
      border-radius: 4px;
      font-size: 13px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }
    .rank-num-1 { background: #ff5252; }
    .rank-num-2 { background: #ff9800; }
    .rank-num-3 { background: #ffc107; }
    .rank-avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      flex-shrink: 0;
      background: #f0f0f0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    .rank-name {
      font-size: 14px;
      color: #333;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.banner-carousel {
  flex: 1;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  background: #1a237e;
  .banner-track {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .banner-slide {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: opacity 0.6s ease-in-out;
    &.active { opacity: 1; }
  }
  .carousel-dots {
    position: absolute;
    bottom: 14px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 3;
    .dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: rgba(255,255,255,0.5);
      transition: all 0.2s;
      cursor: pointer;
      &.active {
        width: 24px;
        border-radius: 4px;
        background: #fff;
      }
    }
  }
}

/* 通用区块 */
.block-section {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #e3f2fd 0%, #fff 100%);
  padding: 10px 16px;
  border-radius: 6px;
  margin-bottom: 18px;
  .section-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    .title-bar {
      width: 4px;
      height: 18px;
      background: #4A90E2;
      border-radius: 2px;
      margin-right: 8px;
    }
  }
  .more-link {
    font-size: 13px;
    color: #888;
    cursor: pointer;
    transition: color 0.2s;
    &:hover { color: #4A90E2; }
  }
}

/* 推荐图标 */
.recommend-icons {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.game-icon-item {
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-4px);
    .game-icon { box-shadow: 0 6px 16px rgba(74,144,226,0.3); }
  }
}

.game-icon {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  margin: 0 auto 8px;
  overflow: hidden;
  background: #f0f0f0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: box-shadow 0.2s;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.game-name {
  font-size: 13px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 大卡片 */
.big-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.big-card {
  height: 180px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  }
  .big-card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, transparent 50%, rgba(0,0,0,0.7) 100%);
  }
  .big-card-info {
    position: absolute;
    bottom: 14px;
    left: 16px;
    display: flex;
    align-items: center;
    z-index: 2;
    .big-card-icon {
      width: 36px;
      height: 36px;
      background: rgba(255,255,255,0.9);
      border-radius: 8px;
      overflow: hidden;
      margin-right: 10px;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    .big-card-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      text-shadow: 0 1px 4px rgba(0,0,0,0.6);
    }
  }
}

.big-card-1 {
  background: linear-gradient(135deg, #8B0000 0%, #DC143C 50%, #FF6347 100%);
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 70% 50%, rgba(255,200,100,0.4), transparent 50%);
  }
}

.big-card-2 {
  background: linear-gradient(135deg, #2C3E50 0%, #34495E 50%, #5D6D7E 100%);
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 60% 40%, rgba(241,196,15,0.4), transparent 50%);
  }
}

/* 卡片行 */
.card-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.game-card {
  height: 150px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  transition: transform 0.2s, box-shadow 0.2s;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.12);
  }
  .game-card-img {
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    .game-card-icon {
      width: 72px;
      height: 72px;
      border-radius: 14px;
      object-fit: cover;
      box-shadow: 0 4px 10px rgba(0,0,0,0.15);
      background: rgba(255,255,255,0.6);
      display: block;
    }
  }
  .game-card-name {
    height: 40px;
    background: rgba(255,255,255,0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #333;
    font-weight: 500;
  }
}

/* 微信游戏网格 */
.wechat-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
}

.wechat-item {
  text-align: center;
  cursor: pointer;
  padding: 10px 4px;
  border-radius: 8px;
  transition: background 0.2s, transform 0.2s;
  &:hover {
    background: #f5f9ff;
    transform: translateY(-2px);
  }
  .wechat-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto 8px;
    background: #f0f0f0;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .wechat-name {
    font-size: 13px;
    color: #333;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .wechat-tag {
    font-size: 11px;
    color: #999;
    margin-top: 2px;
  }
}

/* 页脚 */
.footer {
  background: #222222;
  color: #ccc;
  padding: 30px 0;
  margin-top: 20px;
  .footer-inner {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
  }
  .footer-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 14px;
    img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      object-fit: cover;
      background: #fff;
      display: block;
    }
  }
  .footer-links {
    margin-bottom: 12px;
    a {
      color: #ccc;
      font-size: 13px;
      cursor: pointer;
      transition: color 0.2s;
      &:hover { color: #4A90E2; }
    }
    .divider {
      color: #555;
      margin: 0 8px;
      font-size: 12px;
    }
  }
  .footer-copyright {
    font-size: 12px;
    color: #888;
    line-height: 1.8;
  }
}
</style>
